export default __webpack_public_path__ + "static/media/equipment-servicing-banner.48f6f113.jpg";